export class MaterialGridViewItem {
    id?: string;
    name: string;
    userName?: string;
    modifiedDate?: Date | null;
    dangerousLevel?: number| null;
    constructor(materialGridViewItem?: MaterialGridViewItem) {
        this.id = materialGridViewItem?.id;
        this.name = materialGridViewItem?.name || "";
        this.userName = materialGridViewItem?.userName;
        this.modifiedDate = materialGridViewItem?.modifiedDate;
        this.dangerousLevel = materialGridViewItem?.dangerousLevel;
    }
}
